function FeaturedPostWidget(){

    function hasClass(el, className) {
        return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
    }

    function addClass(el, className) {
        if (el.classList) el.classList.add(className);
        else if (!hasClass(el, className)) el.className += ' ' + className;
    }

    function removeClass(el, className) {
        if (el.classList) el.classList.remove(className);
        else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
    }

    var widget = document.querySelector('.pa_issue_widget');

    if( !widget ) {
        return; // No widget HTML found
    }

    var num_per_load = parseInt(widget.getAttribute('data-max-visible'));
    var offset = parseInt(widget.getAttribute('data-offset'));

    var items = widget.querySelectorAll('.public-affairs-section-container');
    var total = items.length;

    // get timestamp then round to days
    // Offset by 11.5 hours so switchover happens at midnight EST
    var day_num = Math.floor(((Date.now() / 1000 / 60 / 60) + 11.5) / 24);

    var new_html = '';

    for(var i = 0; i < total; i++) {

        /* Use modulus to determine cycle between total available, 
           set by day num and offset, within range specified by num-per-load */
        var this_order = (day_num + offset + i) % total;
        if( i < num_per_load ) {
            new_html += items[this_order].outerHTML;
            console.log('here');
        }
        console.log(day_num+' '+offset+' '+i+' '+this_order);
    }

    widget.innerHTML = new_html;
    addClass(widget, 'loaded');

}

export default FeaturedPostWidget;